export default __webpack_public_path__ + "static/media/project-status-money-give.a0a444d0.svg";